module.exports = __webpack_public_path__ + "static/media/MetaClan_Text.928703eb.png";